import React from 'react';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';
import { COMPANY_INFO } from '../data/content';

const FloatingPhone = () => {
  return (
    <motion.a
      href={`tel:${COMPANY_INFO.phone.replace(/\s/g, '')}`}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: 'spring', stiffness: 260, damping: 20 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      className="fixed bottom-6 right-6 z-50 bg-primary-orange text-white p-4 rounded-full shadow-2xl hover:bg-orange-600 transition-colors flex items-center justify-center"
      aria-label="Pozovite nas"
    >
      <Phone size={28} fill="currentColor" />
      <div className="absolute inset-0 rounded-full bg-primary-orange animate-ping opacity-75 -z-10"></div>
    </motion.a>
  );
};

export default FloatingPhone;
